import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDBVHMQXkt96VVsYncjp5ZbS51Da-rUsN4",
  authDomain: "bodysolutions-5dd20.firebaseapp.com",
  projectId: "bodysolutions-5dd20",
  storageBucket: "bodysolutions-5dd20.firebasestorage.app",
  messagingSenderId: "595023516432",
  appId: "1:595023516432:web:74ba5bccc6426024098b95",
  measurementId: "G-VD9L9FCRPL"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };